// extracted by mini-css-extract-plugin
export default {"control":"DefaultHomePageTabs-module__control--fc36e"};